import React from "react";
import { useNavigate } from "react-router-dom";
import "./TestingPage.scss";
import Seo from "../../components/Seo/Seo";

const PROJECT_PAGES = [
  { label: "Home Page", path: "/" },
  { label: "Home Page (alias)", path: "/homepage" },
  { label: "Our Services", path: "/ourservices" },
  { label: "iOS Development", path: "/iosdevelopment" },
  { label: "Contact Page", path: "/contactpage" },
  { label: "Privacy Policy", path: "/privacy" },
  { label: "Terms & Conditions", path: "/termcondition" },
  { label: "Packages SEO", path: "/packagesseo" },
  { label: "Blog Listing", path: "/bloglisting" },
  { label: "Blog Page", path: "/blogpage/1" },
  { label: "Verify Certificate", path: "/verifycertificate" },
  { label: "All Certificates", path: "/allcertificates" },
  { label: "Case Study", path: "/casestudy/fintech" },
  { label: "Portfolio", path: "/portfolio" },
  { label: "Portfolio Listing", path: "/portfoliolisting" },
  { label: "About Us", path: "/aboutus" },
  { label: "Login", path: "/login" },
  { label: "Details Page", path: "/detailspage" },
  { label: "Leave Page", path: "/leave" },
  { label: "Apply Leave", path: "/applyleave" },
  { label: "Career Page", path: "/career" },
  { label: "Inner Page", path: "/innerpage" },
  { label: "App Map", path: "/appmap" },
  { label: "Caption Publishing", path: "/captionPublishing" },
];

const TestingPage = () => {
  const navigate = useNavigate();

  const clickToNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="testing-page">
      <Seo title="Testing" path="/testing" noindex />
      <h1 className="testing-page__title">Project Pages</h1>
      <p className="testing-page__subtitle">
        Open any screen below to review UI progress.
      </p>

      <div className="testing-page__list">
        {PROJECT_PAGES.map((page) => (
          <div
            key={page.path}
            className="testing-page__item"
            onClick={() => clickToNavigate(page.path)}
          >
            <p className="testing-page__link">{page.label}</p>
            <span className="testing-page__path">{page.path}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestingPage;
